import React from 'react';

import Page from '@feathr/extender/App/Page';

import BillableAdd from './BillableAdd';

function BillableAddPage() {
  return (
    <Page title={'New Billing Configuration'}>
      <BillableAdd />
    </Page>
  );
}

export default BillableAddPage;
